<script>
import MetisMenu from "metismenujs/dist/metismenujs";

export default {
  components: {},
  mounted: function() {
    const sidebarLayout = localStorage.getItem("sidebar-layout");
    document.body.setAttribute("data-sidebar", "dark");
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }
    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) parent5.classList.add("mm-active");
          }
        }
      }
    }
  },
  methods: {
    
  },
  created() {

  },
};
</script>
<template>
    <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul id="side-menu" class="metismenu list-unstyled">
            <li class="menu-title">Menu</li>
            <li v-if="user.rol=='Admin' || user.rol=='Vendedor'">
                <a href="/" class="side-nav-link-ref">
                    <i class="bx bx-home-circle"></i>
                    <span>Inicio</span>
                </a>
            </li>
            <!-- <li>
                <a href="javascript: void(0);" class="has-arrow">
                    <i class="bx bx-wrench font-size-16 align-middle mr-1"></i>
                    <span>Configuracion</span>
                </a>
                <ul class="sub-menu" aria-expanded="true">
                    <li v-if="user.sucursal.categorizaciones.includes('Categorias')">
                        <a href="/web/config/categorias" class="side-nav-link-ref" >Categorias</a>
                    </li>
                    <li v-if="user.sucursal.categorizaciones.includes('Canales')">
                        <a href="/web/config/canales" class="side-nav-link-ref" >Canales</a>
                    </li>
                    <li v-if="user.sucursal.categorizaciones.includes('Turnos')">
                        <a href="/web/config/turnos" class="side-nav-link-ref" >Turnos</a>
                    </li>
                    <li v-if="user.sucursal.categorizaciones.includes('Marcas')">
                        <a href="/web/config/marcas" class="side-nav-link-ref" >Marcas</a>
                    </li>
                    <li v-if="user.sucursal.categorizaciones.includes('Medidas')">
                        <a href="/web/config/medidas" class="side-nav-link-ref">Medidas</a>
                    </li>
                    <li v-if="user.sucursal.categorizaciones.includes('Clasificaciones')">
                        <a href="/web/config/tipos" class="side-nav-link-ref" >Clasificaciones</a>
                    </li>
                    <li v-if="user.sucursal.categorizaciones.includes('Ubicaciones')">
                        <a href="/web/config/ubicaciones" class="side-nav-link-ref" >Ubicaciones</a>
                    </li>
                    <li v-if="user.sucursal.categorizaciones.includes('Clientes')">
                        <a href="/web/config/clientes" class="side-nav-link-ref">Clientes</a>
                    </li>
                    <li>
                        <a href="/web/config/ingredientes" class="side-nav-link-ref">Ingredientes</a>
                    </li>
                    <li>
                        <a href="/web/config/productos" class="side-nav-link-ref">Productos</a>
                    </li>
                    <li>
                        <a href="/web/config/configuracion" class="side-nav-link-ref">Configuración</a>
                    </li>
                </ul>
            </li> -->
            <li v-if="user.rol=='Admin'">
              <a href="/web/config/ingredientes" class="side-nav-link-ref">
                <i class="bx bx-cog"></i>
                Inventario
              </a>
            </li>
            <li>
              <a v-if="user.rol=='Admin'" href="/web/config/configuracion" class="side-nav-link-ref" >
                <i class="bx bx-wrench"></i>
                <span>Configuración</span>
              </a>
            </li>
            <!--<li v-if="user.rol=='Admin' || user.rol=='Vendedor'">
              <a href="/web/config/comandas" class="side-nav-link-ref" >
                <i class="bx bx-notepad"></i>
                <span>Comandas</span>
              </a>
            </li>-->
            <li>
              <a v-if="user.rol=='Admin'" href="/web/config/reportes" class="side-nav-link-ref" >
                <i class="bx bx-line-chart"></i>
                <span>Análisis</span>
              </a>
            </li>
            <li>
              <a v-if="user.rol=='Admin'" href="/web/config/profile" class="side-nav-link-ref" >
                <i class="bx bx-user"></i>
                <span>Perfil</span>
              </a>
            </li>
            <!-- <li v-if="user.id==1">
              <a href="/web/config/socios" class="side-nav-link-ref" >
                <i class="bx bx-user"></i>
                <span>Socios</span>
              </a>
            </li> -->
        </ul>
    </div>
</template>
